module.exports = __webpack_public_path__ + "static/media/bd3.af9892f1.jpg";